
import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import LiveView from '../../routes/liveview';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 1024,
    bgcolor: 'background.paper',
    borderRadius: '6px',
    border: '1px solid #fff',
    boxShadow: 24,
    p: 2,
    textAlign: 'center',
    overflow: 'auto',
    minHeight: '740px',
    maxHeight: '100%',
    display: 'block'
};

export default function SingleLive({ onUpdate, index, widget }) {

    const [selected, setSelected] = useState(null);
    const isInModification = widget[0]?.data && Object.keys(widget[0]?.data)?.length > 0;

    //Mui Modal
    const [openModal, setOpenModal] = useState(false);
    const handleOpen = () => setOpenModal(true);
    //const handleClose = () => setOpenModal(false);

    useEffect(() => {
        handleOpen();
        /* if (isInModification) {
            console.log('SingleLive in modifica: ', isInModification, selected)
        } */
    }, [selected]);

    //Gestione chiusura del modal
    function handleClose(event, reason) {
        //console.log(event, reason);
        switch (reason) {
            case 'backdropClick':
                return;
            case 'escapeKeyDown':
                return;
            default:
                setOpenModal(false);
        }
    }

    function handleUpdateCB(arrId) {
        //console.log('array di Id di ritorno da Liveview', arrId);
        setSelected(arrId[0]);
    }

    /* useEffect(() => {
        console.log('selected dentro SingleLive: ', selected);
    }, [selected]); */

    return (
        <>
            <Modal
                aria-labelledby="sl-modal-title"
                aria-describedby="sl-modal-description"
                open={openModal}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
                sx={isInModification ? { minHeight: "900px" } : {}}
            //disableEscapeKeyDown={true} 
            >
                <Fade in={openModal}>
                    <Box sx={style}>
                        <Typography id="sl-modal-title" variant="h6" component="h2"
                            style={{ marginBottom: "20px" }}>
                            {isInModification ? 'Modifica Single Live' : 'New Single Live'}
                        </Typography>
                        <div className="row" style={{ margin: "auto", textAlign: "center" }}>
                            {isInModification ?
                                <div className="col-12">
                                    <div className="fw-bold p-1">Live in uso</div>
                                    <LiveView onUpdateCB={handleUpdateCB} liveId={widget[0]?.data?.id} isSelecting={false}
                                        isMultipleSelection={false} light={true} tableHeight={'116px'} onlyVisualization={true}></LiveView>
                                    <div className="fw-bold p-1">Seleziona una nuova Live dall'elenco</div>
                                    <LiveView onUpdateCB={handleUpdateCB} isSelecting={true} isMultipleSelection={false} light={true} tableHeight={'436px'}></LiveView>
                                </div>
                                :
                                <div className="col-12">
                                    <div className="fw-bold p-1">Seleziona una Live dall'elenco</div>
                                    <LiveView onUpdateCB={handleUpdateCB} isSelecting={true} isMultipleSelection={false} light={true} tableHeight={'436px'}></LiveView>
                                </div>
                            }
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                                <button type="button" className="btn btn-secondary"
                                    style={{ minWidth: '6rem', marginLeft: '10px', float: "left" }}
                                    onClick={() => { ((widget[0]?.data && isInModification) ? onUpdate(null, -1) : onUpdate(null, index)); handleClose(); }}>
                                    Chiudi
                                </button>
                            </div>
                            <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                                {(selected != null) ?
                                    <button type="button" className="btn btn-success"
                                        style={{ minWidth: '6rem', marginRight: '10px', float: "right" }}
                                        //onClick={() => { onUpdate(selected, index); handleClose(); }}>
                                        onClick={() => {
                                            ((widget[0]?.data && isInModification)
                                                ? onUpdate(selected ? { id: selected } : { id: widget[0]?.data?.id }, index)
                                                : onUpdate({ id: selected }, index)); handleClose();
                                        }}>
                                        Conferma
                                    </button>
                                    : ''}
                            </div>
                        </div>
                    </Box>
                </Fade>
            </Modal>
        </>
    );
}